export const lightTheme = {
    body: '#eaeaea',
    text: '#363537',
    toggleBorder: '#eaeaea',
    background: '#363537',
    infoboxColor: '#ffffff',
    infoboxText: '#6c757d',
    tableOddColor: '#eaeaea',
    graphTextColor: '#363537'
}
export const darkTheme = {
    body: '#363537',
    text: '#FAFAFA',
    toggleBorder: '#6B8096',
    background: '#999',
    infoboxColor: '#646165',
    infoboxText: '#FAFAFA',
    tableOddColor: '#575558',
    graphTextColor: '#FAFAFA'
}